import { Trip } from "../Trip/Trip";
import * as moment from 'moment';

export class TripWaitTime{

    tripId:string;
    tripTime : number;
    time:any;

    constructor(trip:Trip){

        this.tripTime = trip.time;
        this.tripId = trip.id;
        this.time = moment(trip.reportDate).toDate().toString();
    }
}


// WEBPACK FOOTER //
// ./src/app/DataStructures/VehicleReservation/TripWaitTime.ts